/**
 * Mobile Menu Functionality
 * Handles opening/closing of mobile navigation menu and accordion subnavs.
 *
 * @package ppzms
 */

class MobileMenu {
	constructor() {
		this.toggle = document.querySelector('[data-mobile-menu-toggle]');
		this.menu = document.querySelector('[data-mobile-menu]');
		this.overlay = document.querySelector('[data-mobile-menu-overlay]');
		this.body = document.body;

		if (!this.toggle || !this.menu || !this.overlay) {
			return;
		}

		this.isOpen = false;
		this.init();
	}

	init() {
		// Toggle button click
		this.toggle.addEventListener('click', () => this.toggleMenu());

		// Overlay click
		this.overlay.addEventListener('click', () => this.closeMenu());

		// Close menu on menu item click (except links with their own navigation handlers)
		const menuLinks = this.menu.querySelectorAll('a');
		menuLinks.forEach((link) => {
			link.addEventListener('click', () => {
				if (!link.classList.contains('scroll-to-form') && !link.classList.contains('exit-modal')) {
					this.closeMenu();
				}
			});
		});

		// Accordion toggles for dropdown parents
		const accordionToggles = this.menu.querySelectorAll('.menu-item-has-children > .menu-item-toggle');
		accordionToggles.forEach((btn) => {
			btn.addEventListener('click', (e) => {
				e.preventDefault();
				this.toggleAccordion(btn);
			});
		});

		// Close on Escape key
		document.addEventListener('keydown', (e) => {
			if (e.key === 'Escape' && this.isOpen) {
				this.closeMenu();
			}
		});

		// Close on window resize
		window.addEventListener('resize', () => {
			if (this.isOpen) {
				this.closeMenu();
			}
		});
	}

	toggleAccordion(btn) {
		const parent = btn.closest('.menu-item-has-children');
		const panel = parent ? parent.querySelector('.sub-menu') : null;
		if (!parent || !panel) {
			return;
		}

		const willOpen = btn.getAttribute('aria-expanded') !== 'true';

		// Close other open accordions
		this.menu.querySelectorAll('.menu-item-has-children.is-open').forEach((openItem) => {
			if (openItem === parent) {
				return;
			}
			const openBtn = openItem.querySelector('.menu-item-toggle');
			const openPanel = openItem.querySelector('.sub-menu');
			openItem.classList.remove('is-open');
			if (openBtn) {
				openBtn.setAttribute('aria-expanded', 'false');
			}
			if (openPanel) {
				openPanel.classList.remove('is-open');
				openPanel.setAttribute('hidden', '');
			}
		});

		btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
		parent.classList.toggle('is-open', willOpen);
		panel.classList.toggle('is-open', willOpen);
		if (willOpen) {
			panel.removeAttribute('hidden');
		} else {
			panel.setAttribute('hidden', '');
		}
	}

	toggleMenu() {
		if (this.isOpen) {
			this.closeMenu();
		} else {
			this.openMenu();
		}
	}

	openMenu() {
		this.isOpen = true;
		this.menu.classList.add('is-open');
		this.overlay.classList.add('is-open');
		this.toggle.setAttribute('aria-expanded', 'true');
		this.body.classList.add('mobile-menu-open');
	}

	closeMenu() {
		this.isOpen = false;
		this.menu.classList.remove('is-open');
		this.overlay.classList.remove('is-open');
		this.toggle.setAttribute('aria-expanded', 'false');
		this.body.classList.remove('mobile-menu-open');
	}
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => {
		new MobileMenu();
	});
} else {
	new MobileMenu();
}
